import { useSelector } from "react-redux";
import { CartOptional } from "../interfaces/Cart";
import { StoreState } from "../interfaces/storeState";

export const useCartOptional = (): CartOptional => useSelector(getCartOptional);

const getCartOptional = (state: StoreState): CartOptional => {
  if (!state.cart?.optional) {
    return undefined;
  }

  return state.cart.optional;
};
